import api from "@/services/api";
import {
  CreateSupplier,
  CreateSupplierClosure,
  Supplier,
  SupplierClosure,
  UpdateSupplier,
  UpdateSupplierClosure,
} from "@/types/supplier";

export class SupplierRepository {
  async findAll(): Promise<Supplier[]> {
    const response = await api.get<Supplier[]>("/v1/suppliers");

    return response.data;
  }

  async create(data: CreateSupplier): Promise<Supplier> {
    const response = await api.post<Supplier>("/v1/suppliers", data);

    return response.data;
  }

  async update(id: string, data: UpdateSupplier): Promise<Supplier> {
    const response = await api.patch<Supplier>(`/v1/suppliers/${id}`, data);

    return response.data;
  }

  async delete(id: string): Promise<Supplier> {
    const response = await api.delete<Supplier>(`/v1/suppliers/${id}`);

    return response.data;
  }

  async findClosures(supplierId: string): Promise<SupplierClosure[]> {
    const response = await api.get<SupplierClosure[]>(
      `/v1/suppliers/${supplierId}/closures`,
    );

    return response.data;
  }

  async createClosure(
    supplierId: string,
    data: CreateSupplierClosure,
  ): Promise<SupplierClosure> {
    const response = await api.post<SupplierClosure>(
      `/v1/suppliers/${supplierId}/closures`,
      data,
    );

    return response.data;
  }

  async updateClosure(
    supplierId: string,
    closureId: string,
    data: UpdateSupplierClosure,
  ): Promise<SupplierClosure> {
    const response = await api.patch<SupplierClosure>(
      `/v1/suppliers/${supplierId}/closures/${closureId}`,
      data,
    );

    return response.data;
  }

  async deleteClosure(supplierId: string, closureId: string): Promise<void> {
    await api.delete(`/v1/suppliers/${supplierId}/closures/${closureId}`);
  }
}
